import { useKeyboardShortcutsDialogStore } from '@/stores/keyboard-shortcuts.store';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@ominiflow/ui';

const SHORTCUTS = [
  { group: 'Global', key: 'Ctrl + K', description: 'Abrir Command Palette' },
  { group: 'Global', key: '?', description: 'Mostrar esta tela de atalhos' },
  { group: 'Global', key: 'Escape', description: 'Fechar modal / painel aberto' },
  { group: 'Sidebar do Inbox', key: 'J', description: 'Próxima conversa' },
  { group: 'Sidebar do Inbox', key: 'K', description: 'Conversa anterior' },
  { group: 'Chat — ações', key: 'E', description: 'Resolver conversa' },
  { group: 'Chat — ações', key: 'A', description: 'Atribuir para mim' },
  { group: 'Chat — ações', key: 'P', description: 'Ciclar prioridade (↑)' },
  { group: 'Chat — composição', key: 'R', description: 'Focar no campo de resposta' },
  { group: 'Chat — composição', key: 'N', description: 'Alternar nota privada / pública' },
  { group: 'Chat — composição', key: 'Ctrl + Enter', description: 'Enviar mensagem' },
  { group: 'Chat — composição', key: '/', description: 'Abrir respostas rápidas' },
] as const;

const GROUPS = [...new Set(SHORTCUTS.map((s) => s.group))];

export function KeyboardShortcutsDialog() {
  const open = useKeyboardShortcutsDialogStore((s) => s.open);
  const setOpen = useKeyboardShortcutsDialogStore((s) => s.setOpen);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Atalhos de Teclado</DialogTitle>
          <DialogDescription>Acelere seu fluxo de trabalho com esses atalhos.</DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-5 mt-2 max-h-[60vh] overflow-y-auto pr-1">
          {GROUPS.map((group) => (
            <div key={group}>
              <p className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground mb-2">
                {group}
              </p>
              <div className="flex flex-col gap-1">
                {SHORTCUTS.filter((s) => s.group === group).map((s) => (
                  <div
                    key={s.key}
                    className="flex items-center justify-between rounded-md px-3 py-2 text-sm hover:bg-muted/50"
                  >
                    <span className="text-foreground">{s.description}</span>
                    <div className="flex items-center gap-1">
                      {s.key.split(' + ').map((part, i) => (
                        <span key={part} className="flex items-center gap-1">
                          {i > 0 && <span className="text-muted-foreground text-xs">+</span>}
                          <kbd className="inline-flex h-6 min-w-6 items-center justify-center rounded border bg-muted px-1.5 font-mono text-[11px] font-medium text-muted-foreground shadow-sm">
                            {part}
                          </kbd>
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
